exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.prev[data-v-9d650326]{float:left;margin-left:86px\n}\n.next[data-v-9d650326]{float:left\n}\ntable tr:not(:last-of-type) td[data-v-9d650326]{border-bottom:1px solid #8a734b\n}\n.avatar[data-v-9d650326]{margin:0 auto\n}\n.username[data-v-9d650326]{font-size:21px\n}\n.level[data-v-9d650326]{font-size:13px\n}\n", ""]);

// exports
